<template>
  <div class="do-scheduler-sort">
    <DDropdown :isShowDots="false"
               :propOffset="[0, 8]"
               :isCloseOnDropdownClick="false">
      <button class="do-bttn do-bttn__filter" slot="title">
        <span class="icon-shuffle2"></span>
        {{ i18n['sort_by'] }}
      </button>
      <ul slot="list" class="do-filters__filter__dropdown">
        <li v-for="option in options"
            :key="option.value"
            @click="select(option.value)"
            class="do-filters__filter__dropdown__item"
            :class="{'do-filters__filter__dropdown__item--selected': option.selected}">
          {{ option.name }}
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-check"><circle cx="12" cy="12" r="10" class="primary"></circle> <path d="M10 14.59l6.3-6.3a1 1 0 0 1 1.4 1.42l-7 7a1 1 0 0 1-1.4 0l-3-3a1 1 0 0 1 1.4-1.42l2.3 2.3z" class="secondary"></path></svg>
        </li>
      </ul>
    </DDropdown>
  </div>
</template>

<script>
import DDropdown from '../../common/DDropdown.vue'

const I18N = {
  da: {
    name: 'Navn',
    pools: 'Vikarpulje (høj til lav)',
    poolsAsc: 'Vikarpulje (lav til høj)',
    workHours: 'Arbejdstid',
    proposals: 'Forslag',
    sort_by: 'Sortering af vikarer'
  },
  nb: {
    name: 'Navn',
    pools: 'Vikarpulje (høy til lav)',
    poolsAsc: 'Vikarpulje (lav til høy)',
    workHours: 'Arbeidstid',
    proposals: 'Suggestions',
    sort_by: 'Sorter vikarer'
  },
  en: {
    name: 'Name',
    pools: 'Substitute pool (high to low)',
    poolsAsc: 'Substitute pool (low to high)',
    workHours: 'Work hours',
    proposals: 'Forslag',
    sort_by: 'Sort substitutes by'
  }
}

export default {
  components: {DDropdown},
  props: {
    selected: {
      default: 'name'
    },
    locale: {
      default: 'da'
    }
  },
  computed: {
    i18n () {
      return I18N[this.locale]
    },
    selectedI18n () {
      const selectedOptions = this.options.find(option => option.value === this.selected)
      return selectedOptions.name || ''
    },
    options () {
      return [
        {value: 'subzen', name: this.i18n['proposals'], selected: this.selected === 'subzen'},
        {value: 'name', name: this.i18n['name'], selected: this.selected === 'name'},
        {value: 'pools', name: this.i18n['pools'], selected: this.selected === 'pools'},
        {value: 'poolsAsc', name: this.i18n['poolsAsc'], selected: this.selected === 'poolsAsc'},
        {value: 'workHours', name: this.i18n['workHours'], selected: this.selected === 'workHours'}
      ]
    }
  },
  methods: {
    select (selected) {
      this.$emit('onSortBy', selected)
    }
  }
}
</script>

<style scoped>
@import "../../../assets/css/variables.css";
.tw-icon {
  width: 1.5rem;
}

.tw-icon .primary {
  fill: transparent;
}

.do-filters__filter__dropdown__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem
}

.do-filters__filter__dropdown__item > .tw-icon {
  opacity: 0;
}

.do-filters__filter__dropdown__item--selected {
  color: var(--purple);
}

.do-filters__filter__dropdown__item--selected > .tw-icon {
  opacity: 1;
}

.do-filters__filter__dropdown__item--selected > .tw-icon .secondary {
  fill: var(--purple);
}
</style>



// WEBPACK FOOTER //
// SchedulerSort.vue?a37b6c9c